module.exports = __webpack_public_path__ + "img/pega_piedras_naturales_de_baja_absorcion.69086342.png";